export default __webpack_public_path__ + "static/media/format-list-bulleted.357a04b4.svg";